export default __webpack_public_path__ + "static/media/sandal2.fba2d57d.jpeg";